import React from 'react';
import { Register } from '../factory';
import { Picker } from 'antd-mobile';
import { queryProfessionalStatuses, queryCertificateTypes, queryEducationList } from '../../../api/dict';

const getApiByName = name => {
    if (name === '职业状态') {
        return queryProfessionalStatuses();
    }
    if (name === '证件类型') {
        return queryCertificateTypes();
    }
    if (name === '学历') {
        return queryEducationList();
    }
};

const fomatePickerData = arr => {
    if (!arr) {
        return arr;
    }

    arr.forEach(item => {
        if (!item.value) {
            item.value = item.id || item.code;
        }
        if (!item.label) {
            item.label = item.name;
        }
    });

    return arr;
};

export const getLabelByValue = (arr: any[], value: string) => {
    for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (item.value === value) {
            return item.label;
        }
    }
    return '';
};

@Register({ name: 'dy-picker' })
class DyPicker extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
        };
    }

    componentWillMount() {
        this.getInitData();
    }
    getInitData = async () => {
        const { name } = this.props;
        let dataRes = await getApiByName(name);
        this.setState({
            data: !dataRes.status ? fomatePickerData(dataRes.result) : [],
        });
    };

    handleChange = val => {
        this.props.onChange({
            key: val[0],
            name: getLabelByValue(this.state.data, val[0]),
        });
    };

    render() {
        let { className, name, value } = this.props;
        const { data } = this.state;

        return (
            <div className={`dy-fm-item ${className ? className : ''}`}>
                <Picker data={data} value={[value ? value.key : '']} cols={1} onOk={this.handleChange}>
                    <div className={`dy-fm-item-pick-view ${value ? 'edited' : ''}`}>{value ? value.name : `请选择${name}`}</div>
                </Picker>
            </div>
        );
    }
}

export default DyPicker;
